import apiClient from "../../api/apiClient";

// ✅ Fetch all users with search query
export const fetchUsers = async ({ search }) => {
  try {
    const response = await apiClient.get(`/users`, { params: { search } });
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw new Error("Failed to fetch users.");
  }
};

// ✅ Fetch all users without filtering
export const fetchAllUsers = async () => {
  try {
    const response = await apiClient.get(`/users/all`);
    return response.data;
  } catch (error) {
    console.error("Error fetching all users:", error);
    throw new Error("Failed to fetch all users.");
  }
};

// ✅ Fetch roles
export const fetchRoles = async () => {
  try {
    const response = await apiClient.get("/roles");
    return response.data;
  } catch (error) {
    console.error("Error fetching roles:", error);
    return [];
  }
};

// ✅ Fetch branches
export const fetchBranches = async () => {
  try {
    const response = await apiClient.get("/branches");
    return response.data;
  } catch (error) {
    console.error("Error fetching branches:", error);
    return [];
  }
};

// ✅ Add new user
export const addUser = async (userData) => {
  try {
    const response = await apiClient.post("/users", userData);
    return response.data;
  } catch (error) {
    console.error("Error adding user:", error);
    throw new Error("Failed to add user.");
  }
};

// ✅ Update user
export const updateUser = async (userId, updatedData) => {
  try {
    const response = await apiClient.put(`/users/${userId}`, updatedData);
    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    throw new Error("Failed to update user.");
  }
};

// ✅ Delete user
export const deleteUser = async (userId) => {
  try {
    await apiClient.delete(`/users/${userId}`);
    return true;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw new Error("Failed to delete user.");
  }
};